// extracted by mini-css-extract-plugin
module.exports = {"img":"AdaptiveImage_img__r7jt5"};